import React, { useState, useEffect } from 'react';
import { Avatar } from '@mui/material';
import { getFileUrl } from '../../services/api';

const S3Avatar = ({ s3Key, children, sx, targetIdentityId = null, accessLevel = 'protected', ...props }) => {
  const [imageUrl, setImageUrl] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const loadImage = async () => {
      if (!s3Key) {
        setImageUrl(null);
        return;
      }

      try {
        setLoading(true);
        const url = await getFileUrl(s3Key, targetIdentityId, accessLevel);
        setImageUrl(url);
      } catch (error) {
        console.error('Error loading avatar image:', error);
        setImageUrl(null);
      } finally {
        setLoading(false);
      }
    };

    loadImage();
  }, [s3Key, targetIdentityId, accessLevel]);

  return (
    <Avatar 
      src={imageUrl || undefined}
      sx={sx} 
      {...props}
    >
      {!imageUrl && children}
    </Avatar>
  );
};

export default S3Avatar;